import React, { useState } from "react";
import PropTypes from "prop-types";
import { Collapse as BsCollapse } from "reactstrap";

const Collapse = ({ canOpen = true, title, header, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="accordion invoice-template-accordion">
      <div className="accordion-item">
        <div className="accordion-header d-flex justify-content-between align-items-center">
          <div className="d-flex accordion-toggle">
            <div
              className="fw-medium flex-grow-1 d-flex align-items-center"
              onClick={() => canOpen && setIsExpanded(!isExpanded)}
              style={{ cursor: "pointer" }}
            >
              <i
                className={`bx bx-chevron-right font-size-24 ${
                  isExpanded && "rotate-90"
                }`}
              />
              <span>{title}</span>
            </div>
          </div>
          <div>{header}</div>
        </div>

        <BsCollapse isOpen={isExpanded} className="accordion-collapse">
          <div className="accordion-body">{children}</div>
        </BsCollapse>
      </div>
    </div>
  );
};

Collapse.propTypes = {
  canOpen: PropTypes.bool,
  title: PropTypes.string,
  header: PropTypes.node,
  children: PropTypes.node,
};

export default Collapse;
